import { render, staticRenderFns } from "./AllCourse.vue?vue&type=template&id=4b8e254c&scoped=true"
import script from "./AllCourse.vue?vue&type=script&lang=ts"
export * from "./AllCourse.vue?vue&type=script&lang=ts"
import style0 from "./AllCourse.vue?vue&type=style&index=0&id=4b8e254c&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b8e254c",
  null
  
)

export default component.exports